export default "__VITE_ASSET__3a569e44__"